/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';
import { TagRequest } from '../../models/tag-request';

export interface CreateTags$Params {
  'Active-Tenant-Identifier': string;
  
    /**
     * Tag body
     */
    body?: TagRequest
}

export function createTags(http: HttpClient, rootUrl: string, params: CreateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
  const rb = new RequestBuilder(rootUrl, createTags.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tag>;
    })
  );
}

createTags.PATH = '/tags';
